import { render, staticRenderFns } from "./QuotaSet.vue?vue&type=template&id=679fe2a2"
import script from "./QuotaSet.vue?vue&type=script&lang=js"
export * from "./QuotaSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports